import { useEffect, useState } from "react";
import api from "@/lib/api";

export const AuthImage = ({ itemId, alt, className, testId }) => {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let url;
    let active = true;
    api
      .get(`/clothing/${itemId}/image`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      })
      .catch(() => active && setFailed(true));
    return () => {
      active = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [itemId]);

  if (failed) {
    return (
      <div className={`${className} bg-bg1 flex items-center justify-center text-epmuted text-xs font-mono-accent`}>
        N/A
      </div>
    );
  }
  if (!src) {
    return <div className={`${className} ep-loading`} data-testid={testId ? `${testId}-loading` : undefined} />;
  }
  return <img src={src} alt={alt} className={className} data-testid={testId} />;
};
